<template>
  <div>
    <b-container fluid class="mt-3">
      <b-row>
        <b-col>
          <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-3 border-bottom border-light">
            <h5>レポート</h5>
            <div class="d-flex float-right">
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card no-body class="shadow-sm">
            <b-tabs card>
              <b-tab active>
                <template #title>
                  <div class="text-dark">家庭ごみレポート</div>
                </template>

                <div class="d-flex">

                  <ul class="nav nav-pills flex-column" style="border-right: 1px solid #dee2e6; min-width: 150px;">
                    <li class="nav-item">
                      <a class="nav-link" href="#" @click.prevent="navigateToReport">
                        <div class="text-dark">日報</div>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link active" href="#">
                        <div class="text-dark">集計</div>
                      </a>
                    </li>
                  </ul>

                  <div class="tab-content flex-grow-1 p-3">
                    <div class="tab-pane active">

                      <b-row align-v="end" class="mb-3">
                        <b-col md="auto">
                          <label class="font-weight-bold">集計単位</label>
                          <b-form-radio-group
                            v-model="summary.unit"
                            :options="unitOptions"
                            name="radio-unit-summary"
                          ></b-form-radio-group>
                        </b-col>
                        <b-col>
                          <label>期間指定（開始）</label>
                          <b-form-input type="date" v-model="summary.period.start" />
                        </b-col>
                        <b-col>
                          <label>期間指定（終了）</label>
                          <b-form-input type="date" v-model="summary.period.end" />
                        </b-col>
                        <b-col>
                          <label>企業</label>
                          <b-form-select v-model="summary.company" :options="companyOptions" @change="handleCompanySelected"></b-form-select>
                        </b-col>
                        <b-col>
                          <label>車両番号</label>
                          <b-form-select v-model="summary.vehicle" :options="vehicleOptions"></b-form-select>
                        </b-col>
                      </b-row>

                      <b-row class="mb-3">
                        <b-col class="text-right">
                           <b-button variant="primary" class="mr-2" @click="handleAggregate" :disabled="summary.isLoading">
                            <b-spinner v-if="summary.isLoading" small></b-spinner>
                            <b-icon v-else icon="search" class="mr-1"></b-icon>
                            集計
                          </b-button>
                          <b-button variant="success" @click="downloadCSV" :disabled="summary.isLoading || !searched || summary.items.length === 0">
                            <b-icon icon="download" class="mr-1"></b-icon>CSVファイルDL
                          </b-button>
                        </b-col>
                      </b-row>

                      <b-overlay :show="summary.isLoading" rounded="sm">
                        <div v-if="searched">
                          <b-table
                            v-if="summary.items.length > 0 || totalRow"
                            striped
                            hover
                            :items="summary.items"
                            :fields="summary.fields"
                            class="text-center"
                            foot-clone
                            thead-class="green-header"
                            sticky-header="60vh"
                          >
                            <template #cell(collection.time)="data">{{ data.value }}</template>
                            <template #cell(collection.stopTime)="data">{{ data.value }}</template>
                            <template #cell(collection.points)="data">{{ data.value }}</template>
                            <template #cell(collection.distance)="data">{{ data.value != null ? data.value.toFixed(2) : '0.00' }}</template>
                            <template #cell(dump.time)="data">{{ data.value }}</template>
                            <template #cell(dump.distance)="data">{{ data.value != null ? data.value.toFixed(2) : '0.00' }}</template>

                            <template #cell(totalWeight)="data">{{ data.value != null ? data.value.toFixed(2) : '0.00' }}</template>
                            <template #cell(odoDistance)="data">{{ data.value != null ? data.value.toFixed(2) : '0.00' }}</template>
                            <template #cell(refuelAmount)="data">{{ data.value != null ? data.value.toFixed(2) : '0.00' }}</template>

                            <template #foot(date)>{{ totalRow ? totalRow.date : '' }}</template>
                            <template #foot(vehicleCount)>{{ totalRow ? totalRow.vehicleCount : '' }}</template>
                            <template #foot(serviceCount)>{{ totalRow ? totalRow.serviceCount : '' }}</template>
                            <template #foot(collection.time)>{{ totalRow ? totalRow.collection.time : '' }}</template>
                            <template #foot(collection.stopTime)>{{ totalRow ? totalRow.collection.stopTime : '' }}</template>
                            <template #foot(collection.points)>{{ totalRow ? totalRow.collection.points : '' }}</template>
                            <template #foot(collection.distance)>{{ totalRow && totalRow.collection.distance != null ? totalRow.collection.distance.toFixed(2) : '0.00' }}</template>
                            <template #foot(dump.time)>{{ totalRow ? totalRow.dump.time : '' }}</template>
                            <template #foot(dump.distance)>{{ totalRow && totalRow.dump.distance != null ? totalRow.dump.distance.toFixed(2) : '0.00' }}</template>
                            <template #foot(totalWeight)>{{ totalRow && totalRow.totalWeight != null ? totalRow.totalWeight.toFixed(2) : '0.00' }}</template>
                            <template #foot(recollectionCount)>{{ totalRow ? totalRow.recollectionCount : '' }}</template>
                            <template #foot(odoDistance)>{{ totalRow && totalRow.odoDistance != null ? totalRow.odoDistance.toFixed(2) : '0.00' }}</template>
                            <template #foot(refuelAmount)>{{ totalRow && totalRow.refuelAmount != null ? totalRow.refuelAmount.toFixed(2) : '0.00' }}</template>
                          </b-table>
                          <p v-else class="text-center text-muted mt-3">対象のデータが見つかりませんでした。</p>
                        </div>
                        <p v-else class="text-center text-muted mt-3">集計ボタンを押してください。</p>
                      </b-overlay>
                    </div>
                  </div>
                </div>

              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import util from '@/common/util.js';

export default {
  name: 'ReportSummary',
  mixins: [util],
  data() {
    return {
      searched: false,
      summary: {
        unit: 'day',
        period: {
          start: new Date().toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
        },
        company: "0",
        vehicle: "",
        isLoading: false,
        items: [],
        fields: [
          // ▼▼▼ この行から sortable: true を削除 ▼▼▼
          { key: 'date', label: '日程' },
          // ▲▲▲ この行から sortable: true を削除 ▲▲▲
          { key: 'vehicleCount', label: '車両台数(台)' },
          { key: 'serviceCount', label: '運行回数(回)' },
          { key: 'collection.time', label: '収集時間' },
          { key: 'collection.stopTime', label: '停車時間' },
          { key: 'collection.points', label: '集積所' },
          { key: 'collection.distance', label: '収集距離(km)' },
          { key: 'dump.time', label: 'ごみ捨て時間' },
          { key: 'dump.distance', label: 'ごみ捨て距離(km)' },
          { key: 'totalWeight', label: 'ごみ量(kg)' },
          { key: 'recollectionCount', label: '再収集回数' },
          { key: 'odoDistance', label: 'ODO差分(km)' },
          { key: 'refuelAmount', label: '給油量(L)' },
        ]
      },
      totalRow: null,
      unitOptions: [
        { text: '日', value: 'day' },
        { text: '月', value: 'month' },
        { text: '年', value: 'year' },
      ],
      companyOptions: [],
      vehicleOptions: [],
    };
  },
  watch: {
    'summary.period.start'(newStartDate) {
      if (newStartDate && this.summary.period.end && newStartDate > this.summary.period.end) {
        this.summary.period.end = newStartDate;
      }
    }
  },
  methods: {
    navigateToReport() {
      this.$router.push('/report');
    },
    async handleAggregate() {
      this.searched = true;
      this.summary.isLoading = true;
      this.summary.items = [];
      this.totalRow = null;

      let companyName = "";
      if (this.summary.company && this.summary.company !== "0") {
        const selectedCompany = this.companyOptions.find(
          (option) => option.value === this.summary.company
        );
        if (selectedCompany) {
          companyName = selectedCompany.text;
        }
      }

      const params = {
        unit: this.summary.unit,
        startDate: this.summary.period.start,
        endDate: this.summary.period.end,
        companyId: companyName,
        vehicleId: this.summary.vehicle,
      };

      try {
        const response = await axios.get(
          this.createAPI("adminreports/getReportSummary"),
          { params }
        );

        const data = response.data;

        if (Array.isArray(data) && data.length > 0) {
          this.totalRow = data.pop();
          this.summary.items = data;

          this.showErrorMessageToast(
            "レポート集計結果",
            `${this.summary.items.length} 件のデータが見つかりました`,
            "info"
          );
        } else {
          this.showErrorMessageToast(
            "レポート集計結果",
            "対象のデータが見つかりませんでした",
            "info"
          );
        }
      } catch (error) {
        console.error("API呼び出し中にエラーが発生しました:", error);
        this.showErrorMessageToast(
          "レポート集計エラー",
          "データの取得に失敗しました。",
          "danger"
        );
      } finally {
        this.summary.isLoading = false;
      }
    },
    downloadCSV() {
        const dataToExport = [...this.summary.items];
        if (this.totalRow) {
            dataToExport.push(this.totalRow);
        }

        if (dataToExport.length === 0) {
            alert('ダウンロードするデータがありません。');
            return;
        }

        const headers = this.summary.fields.map(field => field.label).join(',');
        const rows = dataToExport.map(item => {
            return this.summary.fields.map(field => {
                const keys = field.key.split('.');
                let value = item;
                for (const key of keys) {
                    if (value === null || typeof value === 'undefined') return '';
                    value = value[key];
                }
                if (typeof value === 'number' && field.key !== 'vehicleCount' && field.key !== 'serviceCount' && field.key !== 'collection.points' && field.key !== 'recollectionCount') {
                    return `"${value.toFixed(2)}"`;
                }
                return `"${String(value).replace(/"/g, '""')}"`;
            }).join(',');
        });

        const csvContent = [headers, ...rows].join('\n');
        const blob = new Blob([`\uFEFF${csvContent}`], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', 'report_summary.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },
    handleCompanySelected(companyId) {
      this.vehicleOptions = this.getHouseReportVehicleOptions(companyId ? [companyId] : ['0']);
      const carNoArr = this.vehicleOptions.map(e => e.value);
      if (!carNoArr.includes(this.summary.vehicle)) {
        this.summary.vehicle = "";
      }
    },
  },
  mounted() {
    this.companyOptions = this.getReportHouseholdCompanyOptions();
    this.vehicleOptions = this.getHouseReportVehicleOptions(['0']);
  }
};
</script>

<style scoped>
.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
    color: #212529;
    background-color: #ffc107;
}

.nav-link:not(.active):hover {
    background-color: #e9ecef;
}
</style>

<style>
/* 緑色のヘッダー */
.green-header th {
  background-color: #d9ead3 !important;
  color: rgb(0, 0, 0) !important;
  /* ヘッダーもstickyにするため z-index を指定 */
  z-index: 2 !important;
}

/* フッターを固定するためのスタイル */
.b-table-sticky-header > .table.b-table > tfoot > tr > th {
    position: sticky;
    bottom: 0;
    background-color: #f8f9fa; /* フッターの背景色 (Bootstrapのlightカラー) */
    z-index: 2; /* ヘッダーと同じ階層に設定 */
    font-weight: bold; /* フッターの文字を太字に */
}
</style>
